import { ChipSelect, ChipSelectProps } from 'components/ChipSelect/ChipSelect'
import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'

export enum Tone {
  Conversational = 'Conversational',
  Friendly = 'Friendly',
  Funny = 'Funny',
  Persuasive = 'Persuasive',
  Compelling = 'Compelling',
  Assertive = 'Assertive',
  Professional = 'Professional',
  Informative = 'Informative',
  Courteous = 'Courteous',
  Empathetic = 'Empathetic',
  Emotive = 'Emotive',
  Engaging = 'Engaging',
  Clear = 'Clear',
  Concise = 'Concise',
}

interface Props extends Pick<ChipSelectProps, 'selectionMode' | 'limit'> {
  onChange: (tones: Array<Tone>) => void
  selectedTones: Array<Tone>
  inline?: boolean
}

export const ToneSelect = ({ onChange, selectedTones, limit = 3, selectionMode = 'multiple', inline }: Props) => {
  const tones = Object.values(Tone)
  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    onChange([...selection] as Tone[])
  }

  return (
    <ChipSelect
      limit={limit}
      selectedKeys={selectedTones}
      selectionMode={selectionMode}
      deletable={false}
      onSelectionChange={handleChange}
      inline={inline}
    >
      {tones.map((tone) => (
        <Item key={tone}>{tone}</Item>
      ))}
    </ChipSelect>
  )
}
